export default ["common", "system", "erp"];



// WEBPACK FOOTER //
// ./src/config/modules.js